import { PassTemplateFromJSON, PassTemplateToJSON, } from './PassTemplate';
/**
 * Check if a given object implements the GetPassTemplateResponse interface.
 */
export function instanceOfGetPassTemplateResponse(value) {
    let isInstance = true;
    isInstance = isInstance && "passTemplate" in value;
    return isInstance;
}
export function GetPassTemplateResponseFromJSON(json) {
    return GetPassTemplateResponseFromJSONTyped(json, false);
}
export function GetPassTemplateResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'passTemplate': PassTemplateFromJSON(json['passTemplate']),
    };
}
export function GetPassTemplateResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'passTemplate': PassTemplateToJSON(value.passTemplate),
    };
}
